import { nbsp } from '@ipfabric/frontend-shared-assets/utils/characters';
import { COLOR_FILTERS_STATUS } from '@ipfabric/utils/api/Reports';
import { isReportSeverityKey } from '@ipfabric/utils/report';
import type { FC } from 'react';
import { Badge, severityToBadgeColor } from '../Badge/Badge';
import { Icon } from '../Icon/Icon';
import { intentResultBadgeVariants } from './IntentVerification.styles';
import type { IntentResultBadgeProps } from './IntentVerification.types';

export const IntentResultBadge: FC<IntentResultBadgeProps> = (props) => {
  const count = props.count && props.count >= 1e3 ? '999+' : props.count;

  const getContent = () => {
    if (props.status === COLOR_FILTERS_STATUS.run) {
      return <Icon glyph='fa-spinner' className='fa-spin text-xs' />;
    }
    if (props.status === COLOR_FILTERS_STATUS.notComputed) {
      return <Icon glyph='fa-do-not-enter' className='text-xs' />;
    }
    return count ?? nbsp;
  };

  if (count === undefined && props.severity === null) {
    return null;
  }

  const handleClick = () => {
    if (count === undefined) {
      return;
    }

    if (props.selected) {
      props.onSeverityClick?.(null);
    } else if (props.severity !== null) {
      const severityKeyString = props.severity.toString();
      if (isReportSeverityKey(severityKeyString)) {
        props.onSeverityClick?.(severityKeyString);
      }
    }
  };

  if (props.severity === null) {
    return null;
  }

  return (
    <Badge
      color={severityToBadgeColor[props.severity]}
      className={intentResultBadgeVariants()}
      icon={props.selected ? 'fa-eye' : undefined}
      interactive
      onClick={handleClick}
    >
      {getContent()}
    </Badge>
  );
};
